import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { axiosErrorHandler } from 'common/helpers/axios.helper';
import { AppDispatch, RootState } from 'app/store';
import { IBrandListParams } from 'entities/Brand/Brand.models';
import { brandTransport } from 'entities/Brand/Brand.transport';

interface IState {
  brandList: string[];
  brandCount: number;
  isBrandLoading: boolean;
}

const initialState: IState = {
  brandList: [],
  brandCount: 0,
  isBrandLoading: false,
};

export const brandSlice = createSlice({
  name: 'brand',
  initialState,
  reducers: {
    setBrandList(state, action: PayloadAction<string[]>) {
      state.brandList = action.payload;
    },
    setBrandCount(state, action: PayloadAction<number>) {
      state.brandCount = action.payload;
    },
    setIsBrandLoading(state, action: PayloadAction<boolean>) {
      state.isBrandLoading = action.payload;
    },
  },
});

export const { setBrandList, setBrandCount, setIsBrandLoading } = brandSlice.actions;

export const selectBrandList = (state: RootState) => state.brand.brandList;
export const selectBrandCount = (state: RootState) => state.brand.brandCount;
export const selectIsBrandLoading = (state: RootState) => state.brand.isBrandLoading;

export const brandReducer = brandSlice.reducer;

export const getBrands = (params: IBrandListParams) => async (dispatch: AppDispatch) => {
  dispatch(setIsBrandLoading(true));

  try {
    const response = await brandTransport.get();

    dispatch(setBrandList(response.data));
    dispatch(setBrandCount(response.count));
    params.onSuccess?.();
  } catch (error) {
    axiosErrorHandler(error);
  } finally {
    dispatch(setIsBrandLoading(false));
  }
};
